import { type MetaFunction } from '@remix-run/node'
import nationalgeneral from './nationalgeneral.png'

export const meta: MetaFunction = () => [
	{ title: 'National General Insurance Company' },
	{
		name: 'description',
		content: 'We offer insurance from National General Insurance Company.',
	},
]

export default function Component() {
	return (
		<main className="mx-auto my-10 max-w-7xl">
			<h1 className="py-3 text-4xl font-black">National General</h1>
			<p
				data-paragraph
				className="mt-6 text-xl/7 text-muted-foreground xl:mt-8 xl:text-xl/6 xl:leading-10"
			>
				<img src={nationalgeneral} alt="National General" className="w-64" />
				<h3>Products</h3>
				<p
					data-paragraph
					className="mt-6 text-xl/7 text-muted-foreground xl:mt-8 xl:text-xl/6 xl:leading-10"
				>
					National General Offers both personal and commercial auto insurance,
					as well as motorcycle insurance.
				</p>
				<h3>Contact Information</h3>
				<p
					data-paragraph
					className="mt-6 text-xl/7 text-muted-foreground xl:mt-8 xl:text-xl/6 xl:leading-10"
				>
					Website:{' '}
					<a
						title="National General"
						href="https://www.nationalgeneral.com/"
						target="_blank"
						rel="noopener noreferrer"
					>
						https://www.nationalgeneral.com/ (opens in a new tab)
					</a>
				</p>
				<h3>Claims</h3>
				<p
					data-paragraph
					className="mt-6 text-xl/7 text-muted-foreground xl:mt-8 xl:text-xl/6 xl:leading-10"
				>
					(800) 468-3466
				</p>
				<h3>Make a Payment</h3>
				<p
					data-paragraph
					className="mt-6 text-xl/7 text-muted-foreground xl:mt-8 xl:text-xl/6 xl:leading-10"
				>
					<a
						title="National General Online Payment"
						href="https://www.nationalgeneral.com/"
						target="_blank"
						rel="noopener noreferrer"
					>
						https://www.nationalgeneral.com/ (opens in a new tab)
					</a>
					<br />
					<br />
					Billing Address:
					<br />
					P.O. Box 1018
					<br />
					Winston-Salem, NC 27102
				</p>

				<p
					data-paragraph
					className="mt-6 text-xl/7 text-muted-foreground xl:mt-8 xl:text-xl/6 xl:leading-10"
				>
					Writing Companies:
					<ul>
						<li>GMAC Insurance</li>
						<li>National General</li>
						<li>New South Insurance</li>
						<li>Integon</li>
					</ul>
				</p>
			</p>

			<section>
				<h3>Home Office Address</h3>

				<p
					data-paragraph
					className="mt-6 text-xl/7 text-muted-foreground xl:mt-8 xl:text-xl/6 xl:leading-10"
				>
					National General Insurance Company
					<br />
					5630 University Parkway
					<br />
					Winston-Salem, NC 27105
				</p>
			</section>
		</main>
	)
}
